import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertCardComponent } from './alert-card/alert-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { MatColComponent } from 'libs/portal/src/modules/tools/mat-col/mat-col.component';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';

@NgModule({
  declarations: [AlertCardComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, ToolsModule, MatRowComponent, MatColComponent],
  exports: [AlertCardComponent],
})
export class AlertCardModule {}
